/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { SummaryItemsFamilyTexts } from './SummaryItemsFamilyTexts'
import {
  SummaryItemsFamilyTextsFromJSON,
  SummaryItemsFamilyTextsFromJSONTyped,
  SummaryItemsFamilyTextsToJSON,
} from './SummaryItemsFamilyTexts'

/**
 *
 * @export
 * @interface FullSummaryItem
 */
export interface FullSummaryItem {
  /**
   *
   * @type {string}
   * @memberof FullSummaryItem
   */
  header: string
  /**
   *
   * @type {Array<SummaryItemsFamilyTexts>}
   * @memberof FullSummaryItem
   */
  families: Array<SummaryItemsFamilyTexts>
  /**
   *
   * @type {boolean}
   * @memberof FullSummaryItem
   */
  isActiveChanges: boolean
}

/**
 * Check if a given object implements the FullSummaryItem interface.
 */
export function instanceOfFullSummaryItem(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'header' in value
  isInstance = isInstance && 'families' in value
  isInstance = isInstance && 'isActiveChanges' in value

  return isInstance
}

export function FullSummaryItemFromJSON(json: any): FullSummaryItem {
  return FullSummaryItemFromJSONTyped(json, false)
}

export function FullSummaryItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): FullSummaryItem {
  if (json === undefined || json === null) {
    return json
  }
  return {
    header: json['header'],
    families: (json['families'] as Array<any>).map(
      SummaryItemsFamilyTextsFromJSON,
    ),
    isActiveChanges: json['isActiveChanges'],
  }
}

export function FullSummaryItemToJSON(value?: FullSummaryItem | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    header: value.header,
    families: (value.families as Array<any>).map(SummaryItemsFamilyTextsToJSON),
    isActiveChanges: value.isActiveChanges,
  }
}
